export enum RealMoneyStatus {
  OK = 'OK',
  EXCEEDED_VALIDATION_ATTEMPTS = 'EXCEEDED_VALIDATION_ATTEMPTS',
  INVALID_MOBILE_CODE = 'INVALID_MOBILE_CODE',
  INVALID_MOBILE_PHONE = 'INVALID_MOBILE_PHONE',
  REQUIRED = 'REQUIRED',
  UPDATE_REQUIRED = 'UPDATE_REQUIRED',
  VERIFICATION_REQUIRED = 'VERIFICATION_REQUIRED',
  PLAYER_BLACKLISTED = 'PLAYER_BLACKLISTED',
  DEPOSIT_REQUEST_CANNOT_BE_PROCESSED = 'TXTWCL_Deposit_request_cannot_be_proc_ELL_1',
  BLACKLIST_SERVICE_NOT_AVAILABLE = 'BLACKLIST_SERVICE_NOT_AVAILABLE',
  DBM_ACCOUNT_CLOSED = 'DBM_ACCOUNT_CLOSED',
  DE_BANNED_BY_REGULATOR = 'DE_BANNED_BY_REGULATOR',
  DE_UNBANNED_BY_REGULATOR = 'DE_UNBANNED_BY_REGULATOR',
  USER_BANNED_BY_REGULATOR = 'USER_BANNED_BY_REGULATOR'
}

export enum DepositStatus {
  ACKNOWLEDGED = 'ACKNOWLEDGED',
  ANOTHER_IN_PROGRESS = 'ANOTHER_IN_PROGRESS',
  AUTHENTICATION_REQUIRED = 'AUTHENTICATION_REQUIRED',
  BONUS_ACK_REQUIRED = 'BONUS_ACK_REQUIRED',
  COMPLETED = 'COMPLETED',
  CUMULATIVE_CHECK = 'CUMULATIVE_CHECK',
  ERRORS = 'ERRORS',
  ERR_PLAID_ACCOUNT_REQUIRED = 'ERR_PLAID_ACCOUNT_REQUIRED',
  FAILED = 'FAILED',
  GOOGLE_PAY_CANCELED = 'GOOGLE_PAY_CANCELED',
  GOOGLE_PAY_FAILED = 'GOOGLE_PAY_FAILED',
  GOOGLE_PAY_SESSION_TIMEOUT = 'GOOGLE_PAY_SESSION_TIMEOUT',
  INITIAL = 'INITIAL',
  MISSING_TRANSACTION_ID = 'MISSING_TRANSACTION_ID',
  PARTIALLY_COMPLETED_CHECK = 'PARTIALLY_COMPLETED_CHECK',
  PAYCONIQ_OPEN_APP_FAILED = 'PAYCONIQ_OPEN_APP_FAILED',
  PRECASHING_TIMEOUT = 'PRECASHING_TIMEOUT',
  PROTECTED_BALANCE_ACK_REQUIRED = 'PROTECTED_BALANCE_ACK_REQUIRED',
  RATE_CHANGED = 'RATE_CHANGED',
  REDIRECT = 'REDIRECT',
  REJECTED = 'REJECTED',
  REJECTED_AGE_VERIFY = 'REJECTED_AGE_VERIFY',
  REJECTED_BONUS_MIN_DEPOSIT_REQUIRED = 'REJECTED_BONUS_MIN_DEPOSIT_REQUIRED',
  REJECTED_CARD_BLOCKED = 'REJECTED_CARD_BLOCKED',
  REJECTED_CARD_NOT_VERIFIED = 'REJECTED_CARD_NOT_VERIFIED',
  REJECTED_MAX_DEPOSITS_LIMIT_EXCEEDED = 'REJECTED_MAX_DEPOSITS_LIMIT_EXCEEDED',
  REJECTED_PAYTRU_NSF_ERROR = 'REJECTED_PAYTRU_NSF_ERROR',
  REJECTED_PEP_HIO_THIRD_PARTY = 'REJECTED_PEP_HIO_THIRD_PARTY',
  REJECTED_SELF_EXCLUDED = 'REJECTED_SELF_EXCLUDED',
  REJECTED_TEMP_ACCOUNT_LIMIT_EXCEEDED = 'REJECTED_TEMP_ACCOUNT_LIMIT_EXCEEDED',
  REJECTED_X3D_SECURE2_REDIRECT = 'REJECTED_X3D_SECURE2_REDIRECT',
  REJECTED_X3D_SECURE2_REQUIRED_ERROR = 'REJECTED_X3D_SECURE2_REQUIRED_ERROR',
  REJECTED_X3D_SECURE_REQUIRED_ERROR = 'REJECTED_X3D_SECURE_REQUIRED_ERROR',
  RMF_REQUIRED = 'RMF_REQUIRED',
  TIMEOUT = 'TIMEOUT',
  UPSELL_OFFER = 'UPSELL_OFFER',
  WRONG_PWD = 'WRONG_PWD',
  UNKNOWN_TRANSACTION_ID = 'UNKNOWN_TRANSACTION_ID'
}

export enum TransactionStatus {
  APPROVED = 'A',
  BANNED = 'X',
  CANCELLED = 'C',
  CHEQUE_REQUEST = 'QI', // Legacy - Not in use
  FINALIZATION = 'F',
  HOLD = 'H',
  ISSUED = 'I', // Legacy - Not in use
  LOCKED = 'L',
  MANUALLY_PENDING = 'M',
  PARTIALLY_APPROVED = 'a', // Legacy - Not in use
  PENDING = 'P',
  REDEEM_CANCELLED = 'QN', // Legacy - Not in use
  REJECTED = 'R',
  REJECTED_BY_PROCESSOR = 'Z',
  SENT_FOR_PROCESSING = 'S',
  UNKNOWN = 'U',
  VERIFYING = 'V',
  WAITING = 'W'
}

export enum PaySystemErrorCode {
  AuthenticationRequired = 'AuthenticationRequired',
  BonusAcknowledgement = 'BonusAcknowledgement',
  HostileCard = 'HostileCard',
  MethodVerificationRequired = 'MethodVerificationRequired',
  NoBankTransfers = 'NoBankTransfers',
  NotAvailable = 'notAvailable',
  PaySystemsNotAvailable = 'PaySystemsNotAvailable',
  PepHioAndThirdPartyCheck = 'PepHioAndThirdPartyCheck',
  P2pNoAvailableBalance = 'P2pNoAvailableBalance',
  RMFRequired = 'RMFRequired',
  RateChanged = 'RateChanged',
  RepeatedCashinDeclineOptions = 'RepeatedCashinDeclineOptions',
  TempAccountLimitReached = 'TempAccountLimitReached',
  WbtBankNotAvailable = 'WbtBankNotAvailable',
  WithdrawMethodNotAvailable = 'WithdrawMethodNotAvailable',
  WithdrawNoAvailableBalance = 'WithdrawNoAvailableBalance'
}

export enum VerificationErrorCode {
  ElectronicVerificationFailed = 'ElectronicVerificationFailed',
  ElectronicVerificationFailedTooManyRequests = 'ElectronicVerificationFailedTooManyRequests',
  FiscalCodeAlreadyExists = 'FISCAL_CODE_ALREADY_EXISTS',
  FiscalCodeLen9Required = 'FISCAL_CODE_LEN9_REQUIRED'
}

export enum CashoutStatus {
  ANOTHER_IN_PROGRESS = 'ANOTHER_IN_PROGRESS',
  COMPLETED = 'COMPLETED',
  COMPLETED_PARTIALLY = 'COMPLETED_PARTIALLY',
  ERRORS = 'ERRORS',
  ERR_BANK_ACCOUNT_NOT_FOUND = 'ERR_BANK_ACCOUNT_NOT_FOUND',
  ERR_BANK_ACCOUNT_NOT_VALIDATED = 'ERR_BANK_ACCOUNT_NOT_VALIDATED',
  FAILED = 'FAILED',
  INITIAL = 'INITIAL',
  IN_GRACE_PERIOD = 'IN_GRACE_PERIOD',
  NOT_ALLOWED = 'NOT_ALLOWED',
  NOT_VERIFIED_ACCOUNT = 'NOT_VERIFIED_ACCOUNT',
  OK = 'OK',
  PARTIALLY_COMPLETED_CHECK = 'PARTIALLY_COMPLETED_CHECK',
  PENDING_CASHOUTS = 'PENDING_CASHOUTS',
  REJECTED = 'REJECTED',
  REJECTED_CARD_BLOCKED = 'REJECTED_CARD_BLOCKED',
  REJECTED_PEP_HIO_THIRD_PARTY = 'REJECTED_PEP_HIO_THIRD_PARTY',
  RMF_REQUIRED = 'RMF_REQUIRED',
  TAX_CHANGED = 'TAX_CHANGED',
  TEMP_ACCOUNT_CASHOUT_LIMIT_EXCEEDED = 'TEMP_ACCOUNT_CASHOUT_LIMIT_EXCEEDED',
  TIMEOUT = 'TIMEOUT',
  TOO_EARLY_TO_CASHOUT = 'TOO_EARLY_TO_CASHOUT'
}

export enum CancelledCashoutStatus {
  COMPLETED = 'COMPLETED',
  PARTIALLY_COMPLETED = 'PARTIALLY_COMPLETED',
  INVALID_TRANSACTION_IDS = 'INVALID_TRANSACTION_IDS',
  NOT_CANCELLABLE = 'NOT_CANCELLABLE',
  ZERO_COMPLETED = 'ZERO_COMPLETED',
  ERRORS = 'ERRORS',
  FAILED = 'FAILED',
  TIMEOUT = 'TIMEOUT'
}

export enum TransferErrorCode {
  ACCT_CURRENCY_MISMATCH = 'ACCT_CURRENCY_MISMATCH',
  AML_RESTRICTIONS = 'AML_RESTRICTIONS',
  CASHIN_LIMIT_EXCEEDED = 'CASHIN_LIMIT_EXCEEDED',
  DE_RESTRICTIONS = 'DE_RESTRICTIONS',
  EMAIL_VERIFICATION = 'EMAIL_VERIFICATION',
  ERR_NET_DEPOSIT_LIMIT_EXCEEDED = 'ERR_NET_DEPOSIT_LIMIT_EXCEEDED',
  ERR_SPENDING_BUDGET_LIMIT_EXCEEDED = 'ERR_SPENDING_BUDGET_LIMIT_EXCEEDED',
  GR_RESTRICT_TEMPACCOUNT = 'GR_RESTRICT_TEMPACCOUNT',
  NO_BALANCE = 'NO_BALANCE',
  NO_SUCH_USER = 'NO_SUCH_USER',
  NOT_ALLOW = 'NOT_ALLOW',
  NOT_ALLOWED_WITHOUT_RM_OK = 'NOT_ALLOWED_WITHOUT_RM_OK',
  NOT_AVAILABLE = 'NOT_AVAILABLE',
  RM_NOT_OK = 'RM_NOT_OK',
  SENDER_TRANSFER_IN_LIMIT_REACHED = 'SENDER_TRANSFER_IN_LIMIT_REACHED',
  SUSPEND_RM = 'SUSPEND_RM',
  TRANSFER_RECIPIENT_DISABLED = 'TRANSFER_RECIPIENT_DISABLED',
  TRANSFER_SENDER_DISABLED = 'TRANSFER_SENDER_DISABLED',
  USER_SELF_EXCLUDED = 'USER_SELF_EXCLUDED'
}

export enum AamsErrorCode {
  TEMPORARY_TECHNICAL_ISSUE = '1025',
  ACCOUNT_ALREADY_EXISTS = '1200',
  ACCOUNT_ALREADY_EXISTS_ONE = '1201',
  REQUEST_STILL_BEING_PROCESSED = '1026',
  PROVINCE_OF_RESIDENCE_NOT_VALID = '1232',
  UNSUCCESSFUL_MATCH = '1300',
  PLAYER_UNDER_AGE = '1302',
  INFORMATION_IS_INVALID = '1303',
  FISCAL_CODE_IS_NOT_VALID = '1304',
  UNKNOWN_AAMS_ERROR = 'UNKNOWN_AAMS_ERROR'
}

export enum LugasErrorCode {
  ERR_LUGAS_UNAVAILABLE = 'ERR_LUGAS_UNAVAILABLE',
  ERR_LUGAS_LIMIT_REQUIRED = 'ERR_LUGAS_LIMIT_REQUIRED',
  ERR_LUGAS_DUPLICATE_PLAYER_ID = 'ERR_LUGAS_DUPLICATE_PLAYER_ID',
  ERR_LUGAS_REQUEST_FAILED = 'ERR_LUGAS_REQUEST_FAILED'
}

export enum ESRegulatoryErrorCode {
  INCORRECT_FIRST_NAME = '533',
  INCORRECT_LAST_NAME = '534',
  INCORRECT_SECOND_LAST_NAME = '535',
  INCORRECT_DOB = '536',
  ID_DUPLICATE_FOUND = '537',
  SERVICE_NOT_AVAILABLE = '204',
  CLOSE_RM_FORM = '429'
}

export enum AccountErrorCode {
  MIT_ID_AUTH_REQUIRED = 'mitIdAuthRequired',
  MIT_ID_AUTH_FAILED = 'mitIdAuthFailed'
}
